import React, { useState, useEffect } from 'react';
import { db } from '../../firebaseConfig';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { Typography, Paper, Button, Box, CircularProgress, Alert } from '@mui/material';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css'; // Assurez-vous d'importer le CSS pour le calendrier
import './paramDataPage.css'; 
import { fr } from 'date-fns/locale'; 

const ParamDataPage = () => {
  const [value] = useState(new Date()); // Valeur sélectionnée pour le calendrier
  const [selectedDays, setSelectedDays] = useState({});
  const [deadline, setDeadline] = useState(''); // État pour la date limite de saisie
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  
  useEffect(() => {
    const fetchSelectableDays = async () => {
      try {
        setLoading(true);
        const docRef = doc(db, 'settings', 'selectableDays');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setSelectedDays(data.days || {});
          setDeadline(data.deadline || ''); // Charger la date limite si elle existe
        } else {
          setSelectedDays({});
        }
      } catch (err) {
        setError('Erreur lors de la récupération des jours sélectionnables.');
        console.error('Erreur lors de la récupération des jours sélectionnables :', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSelectableDays();
  }, []);

  const handleDateClick = (date) => {
    const dateString = date.toDateString();
    setSelectedDays(prev => ({
      ...prev,
      [dateString]: !prev[dateString]
    }));
  };

  const saveChanges = async () => {
    try {
      setLoading(true);
      const docRef = doc(db, 'settings', 'selectableDays');
      
      // Récupérer les jours actuellement sélectionnés depuis la base de données
      const currentDaysSnap = await getDoc(docRef);
      const currentDays = currentDaysSnap.exists() ? currentDaysSnap.data().days || {} : {};

      // Trouver les jours à supprimer
      const daysToRemove = Object.keys(currentDays).filter(day => !selectedDays[day]);
      
      // Supprimer les jours non sélectionnés
      const updatedDays = { ...selectedDays };
      daysToRemove.forEach(day => delete updatedDays[day]);

      // Sauvegarder les jours mis à jour et la date limite dans la base de données
      await setDoc(docRef, { days: updatedDays, deadline });
      alert('Les jours sélectionnables ont été sauvegardés avec succès.');
    } catch (err) {
      setError('Erreur lors de la sauvegarde des jours sélectionnables.');
      console.error('Erreur lors de la sauvegarde des jours sélectionnables :', err);
    } finally {
      setLoading(false);
    }
  };

  const renderContent = () => {
    if (loading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
          <CircularProgress />
        </Box>
      );
    }
  
    if (error) {
      return <Alert severity="error">{error}</Alert>;
    }
  
    return (
      <>
        <Box mb={2}>
          <Calendar
            locale={fr} // Utiliser la locale française, par exemple
            value={value}
            onClickDay={handleDateClick}
            tileClassName={({ date }) => {
              const dateString = date.toDateString();
              return selectedDays[dateString] ? 'selected' : 'unselected';
            }}
          />
        </Box>
  
        <Box mb={2} display="flex" justifyContent="flex-end">
          <Button variant="contained" color="success" onClick={saveChanges}>
            Sauvegarder
          </Button>
        </Box>
      </>
    );
  };

  return (
    <div>
      <Paper sx={{ padding: 2, marginTop: 3 }}>
      <Typography variant="h5" gutterBottom sx={{ marginRight: 2, fontWeight: 'bold' }}>
          Sélection des Jours Disponibles
        </Typography>

        {renderContent()}
      </Paper>
    </div>
  );
};

export default ParamDataPage;
